module.exports = __webpack_public_path__ + "assets/img/vip_img.93adbc6d.png";